import React, { useState, useEffect } from 'react';
import {
  FileTextOutlined,
  UserOutlined,
  BookOutlined,
  RobotOutlined,
  CloudOutlined,
  ClockCircleOutlined
} from '@ant-design/icons';
import axios from '../api';

const RecentActivity = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchActivities = async () => {
      try {
        // 尝试从后端获取活动数据
        const response = await axios.get('/api/recent-activities/');
        setActivities(response.data);
      } catch (error) {
        console.log('使用默认活动数据');
        // 如果后端接口不存在，使用默认数据
        setActivities([
          {
            id: 1,
            type: 'document',
            action: 'upload',
            title: '课程大纲.pdf',
            user: '张老师',
            time: '2024-01-15T14:30:00Z',
            description: '上传了新文档'
          },
          {
            id: 2,
            type: 'knowledge',
            action: 'create',
            title: 'AI设计知识库',
            user: '李老师',
            time: '2024-01-15T13:15:00Z',
            description: '创建了新的知识库'
          },
          {
            id: 3,
            type: 'user',
            action: 'register',
            title: '新用户注册',
            user: '王同学',
            time: '2024-01-15T11:45:00Z',
            description: '完成了用户注册'
          },
          {
            id: 4,
            type: 'agent',
            action: 'update',
            title: '课程答疑助手',
            user: '系统管理员',
            time: '2024-01-15T10:20:00Z',
            description: '更新了智能体配置'
          },
          {
            id: 5,
            type: 'cloud',
            action: 'sync',
            title: 'Google Drive同步',
            user: '陈老师',
            time: '2024-01-15T09:30:00Z',
            description: '完成了云文档同步'
          },
          {
            id: 6,
            type: 'document',
            action: 'review',
            title: '学生作业.docx',
            user: '赵老师',
            time: '2024-01-15T08:45:00Z',
            description: '审核了学生提交的作业'
          }
        ]);
      } finally {
        setLoading(false);
      }
    };

    fetchActivities();
  }, []);

  const getActivityIcon = (type) => {
    switch (type) {
      case 'document':
        return <FileTextOutlined style={{ fontSize: 16, color: '#1890ff' }} />;
      case 'knowledge':
        return <BookOutlined style={{ fontSize: 16, color: '#52c41a' }} />;
      case 'user':
        return <UserOutlined style={{ fontSize: 16, color: '#eb2f96' }} />;
      case 'agent':
        return <RobotOutlined style={{ fontSize: 16, color: '#722ed1' }} />;
      case 'cloud':
        return <CloudOutlined style={{ fontSize: 16, color: '#13c2c2' }} />;
      default:
        return <FileTextOutlined style={{ fontSize: 16, color: '#666' }} />;
    }
  };

  const getActionColor = (action) => {
    switch (action) {
      case 'upload':
      case 'create':
        return '#52c41a';
      case 'update':
      case 'edit':
        return '#1890ff';
      case 'delete':
        return '#ff4d4f';

      case 'register':
        return '#722ed1';
      case 'sync':
        return '#13c2c2';
      default:
        return '#666';
    }
  };

  const formatTime = (timeString) => {
    const date = new Date(timeString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffMinutes = Math.floor(diffTime / (1000 * 60));
    const diffHours = Math.floor(diffTime / (1000 * 60 * 60));
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffMinutes < 60) {
      return `${diffMinutes}分钟前`;
    } else if (diffHours < 24) {
      return `${diffHours}小时前`;
    } else if (diffDays < 7) {
      return `${diffDays}天前`;
    } else {
      return date.toLocaleDateString('zh-CN');
    }
  };

  if (loading) {
    return (
      <div style={{
        background: '#fff',
        borderRadius: 16,
        boxShadow: '0 4px 24px #e0e0e0',
        padding: 40,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 200
      }}>
        <div style={{ fontSize: 16, color: '#666' }}>加载活动数据中...</div>
      </div>
    );
  }

  return (
    <div style={{
      background: '#fff',
      borderRadius: 16,
      boxShadow: '0 4px 24px #e0e0e0',
      padding: 40,
    }}>
      <div style={{
        fontSize: 24,
        fontWeight: 700,
        color: '#333',
        marginBottom: 32,
        textAlign: 'center'
      }}>
        最近活动
      </div>

      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        gap: 16,
        maxHeight: 400,
        overflowY: 'auto',
        paddingRight: 8
      }}>
        {activities.map((activity, index) => (
          <div
            key={activity.id}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 16,
              padding: 16,
              borderRadius: 12,
              background: index % 2 === 0 ? '#fafafa' : '#fff',
              border: '1px solid #f0f0f0',
              transition: 'all 0.3s ease',
              cursor: 'pointer',
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateX(8px)';
              e.target.style.boxShadow = '0 4px 16px rgba(0,0,0,0.1)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateX(0)';
              e.target.style.boxShadow = 'none';
            }}
          >
            <div style={{
              background: '#fff',
              borderRadius: 8,
              padding: 8,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: 32,
              minHeight: 32,
              border: '1px solid #e8e8e8'
            }}>
              {getActivityIcon(activity.type)}
            </div>

            <div style={{ flex: 1 }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                marginBottom: 4
              }}>
                <span style={{
                  fontSize: 14,
                  fontWeight: 600,
                  color: '#333'
                }}>
                  {activity.user}
                </span>
                <span style={{
                  fontSize: 14,
                  color: getActionColor(activity.action)
                }}>
                  {activity.description}
                </span>
                <span style={{
                  fontSize: 14,
                  fontWeight: 600,
                  color: '#333'
                }}>
                  {activity.title}
                </span>
              </div>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 4,
                fontSize: 12,
                color: '#999'
              }}>
                <ClockCircleOutlined />
                {formatTime(activity.time)}
              </div>
            </div>
          </div>
        ))}
      </div>

      {activities.length === 0 && (
        <div style={{
          textAlign: 'center',
          color: '#999',
          fontSize: 16,
          padding: 40
        }}>
          暂无活动记录
        </div>
      )}
    </div>
  );
};

export default RecentActivity;
